import Consts from 'Framework/Consts';
import { HttpGetService, IHttpGetServiceProps } from 'Shared/HttpServices/Services/HttpGetService';
import { HttpPostService, IHttpPostServiceProps } from 'Shared/HttpServices/Services/HttpPostService';
import { createAxiosHttpConfig } from 'Shared/HttpServices/Utils/utils';

const AtashsooziHttpConfig = createAxiosHttpConfig({ baseURL: Consts.env.REACT_APP_ATASH_SOOZI_APP_BASE_URL });
export const AtashsooziOmumiHttpGetService = async (props: IHttpGetServiceProps) =>
  HttpGetService({
    API: AtashsooziHttpConfig,
    url: props.url,
    responseType: props.responseType,
    onResult: props.onResult,
    onError: props.onError,
    isFile: props.isFile,
    params: props.params,
  });

export const AtashsooziHttpPostService = async (props: IHttpPostServiceProps) =>
  HttpPostService({
    API: AtashsooziHttpConfig,
    url: props.url,
    body: props.body,
    onResult: props.onResult,
    onError: props.onError,
  });

export default AtashsooziHttpConfig;
